import { cssMap } from "@compiled/react";

import { Layout, Row } from "@/libraries/wpl/foundations/src/grid";
import { PaidCtaPrimary } from "@/patterns/paid-landings/paid-cta-primary/src/paid-cta-primary";
import { PatternCTAMobileProps } from "@/patterns/wpl/cta-primary/src/cta-primary";

import { PaidLandingTypes } from "../src/paid-landing.template";

const ctaStyles = cssMap({
    "jira-software": {
        "color": "ffffff",
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
        "backgroundSize": "cover",
        "backgroundImage":
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/2083gq6qd2uodp3r0ser314i0lyexg74.webp)",

        "@media": {
            "(min-width: 768px)": {
                backgroundImage:
                    "url(https://dam-cdn.atl.orangelogic.com/AssetLink/p6668k6dqoa15f54q38r28f502daxf45.webp)"
            }
        }
    },
    "jira-software-paid-ai": {
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
        "backgroundSize": "cover",
        "backgroundColor": "#cfe1fd",
        "backgroundImage":
            "url(https://dam-cdn.atl.orangelogic.com/CDNLink/AT12FJS8.webp)",
        "@media": {
            "(min-width: 768px)": {
                backgroundImage:
                    "url(https://dam-cdn.atl.orangelogic.com/CDNLink/AT12FJS9.webp)"
            }
        }
    },
    "jira-software-anchor": {
        "color": "#000",
        "backgroundColor": "#0065FF",
        ".text-section .contentBlock-linkFlex": {
            margin: "0"
        }
    },
    "jira-software-rebranded-anchor": {
        "color": "#000",
        "backgroundColor": "#0065FF",
        ".text-section .contentBlock-linkFlex": {
            margin: "0"
        }
    },
    "jira-service-management": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#ffffff",
        backgroundImage:
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/44f6f18c800t60no502m83en3mncy8vk.webp)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
    },
    "jira-service-management-anchor": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#ffffff",
        backgroundImage:
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/02e65q3ai2mia08ll22nni03l4wered3.webp)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
    },
    "confluence-paid": {
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#ffffff",
        backgroundImage:
            "url(https://dam-cdn.atl.orangelogic.com/AssetLink/l5c3xvj171oyg03c3ay7wpkdwvqwm628.svg)",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
    },
    "confluence-anchor": {
        "backgroundImage": `linear-gradient(0deg, #e6fcff 0%, #FFFFFF 100%)`,
        "backgroundPosition": "center",
        "backgroundRepeat": "no-repeat",
        "backgroundSize": "cover",
        "@media": {
            "(min-width: 1024px)": {
                // eslint-disable-next-line local/ensure-wac-token-usage
                backgroundColor: "#e6fcff",
                backgroundImage: `linear-gradient(0deg, #e6fcff99 0%, #FFFFFFFF 91.5%), url("https://dam-cdn.atl.orangelogic.com/AssetLink/jo758cargt230m338cj15v2ec4hg0dh6.svg"), url("https://dam-cdn.atl.orangelogic.com/AssetLink/83p5ewqp62e6j58bdm350e220ao8a12b.svg")`,
                backgroundPosition: "center, bottom left, bottom right",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain"
            }
        }
    },
    "confluence-rebranded-anchor": {
        "backgroundImage": `linear-gradient(0deg, #e6fcff 0%, #FFFFFF 100%)`,
        "backgroundPosition": "center",
        "backgroundRepeat": "no-repeat",
        "backgroundSize": "cover",
        "@media": {
            "(min-width: 1024px)": {
                // eslint-disable-next-line local/ensure-wac-token-usage
                backgroundColor: "#e6fcff",
                backgroundImage: `linear-gradient(0deg, #e6fcff99 0%, #FFFFFFFF 91.5%), url("https://dam-cdn.atl.orangelogic.com/AssetLink/jo758cargt230m338cj15v2ec4hg0dh6.svg"), url("https://dam-cdn.atl.orangelogic.com/AssetLink/83p5ewqp62e6j58bdm350e220ao8a12b.svg")`,
                backgroundPosition: "center, bottom left, bottom right",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain"
            }
        }
    }
});

interface PaidCtaSectionProps {
    ctaProps: PatternCTAMobileProps & { layout?: Layout };
    landingType: PaidLandingTypes;
}

export const PaidCtaSection = ({
    ctaProps,
    landingType
}: PaidCtaSectionProps) => {
    const { layout: ctaLayout = "10", ...otherCtaProps } = ctaProps;
    return (
        <div css={ctaStyles[landingType]}>
            <Row layout={ctaLayout}>
                <PaidCtaPrimary {...otherCtaProps} />
            </Row>
        </div>
    );
};
PaidCtaSection.displayName = "PaidCta";
